(function () {
  'use strict';
  /* =========================================================
     HPD PRODUCT SHOWCASE
     - Quick Add overlay
     - Mobile / iPad scroll progress
     - Shopify Theme Editor support
  ========================================================= */
  /* =========================================================
     QUICK ADD
  ========================================================= */
  function moveQuickAddIntoImage(card) {
    if (!card) return;
    if (card.dataset.hpdQuickAddReady === 'true') return;
    if (card.dataset.hpdShowcaseQuickAdd !== 'true') return;
    var quickAdd = card.querySelector('.quick-add');
    var cardInner = card.querySelector('.card__inner');
    if (!quickAdd || !cardInner) return;
    quickAdd.classList.add(
      'hpd-product-showcase__quick-add-overlay'
    );
    cardInner.appendChild(quickAdd);
    card.dataset.hpdQuickAddReady = 'true';
  }
  /* =========================================================
     SCROLL PROGRESS
  ========================================================= */
  function updateScrollProgress(root) {
    if (!root) return;
    var track = root.querySelector(
      '[data-hpd-product-showcase-track]'
    );
    var progress = root.querySelector(
      '[data-hpd-showcase-progress]'
    );
    var thumb = root.querySelector(
      '[data-hpd-showcase-progress-thumb]'
    );
    if (!track || !progress || !thumb) return;
    /* ---------------------------------------------------------
       Desktop
       Progress bar is mobile + iPad only
    --------------------------------------------------------- */
    if (window.innerWidth > 1024) {
      progress.style.display = 'none';
      thumb.style.width = '';
      thumb.style.transform = '';
      return;
    }
    /* ---------------------------------------------------------
       Temporarily make progress visible before measuring
    --------------------------------------------------------- */
    progress.style.display = 'block';
    var scrollWidth = track.scrollWidth;
    var visibleWidth = track.clientWidth;
    var maxScroll = scrollWidth - visibleWidth;
    /* ---------------------------------------------------------
       Hidden Master Slider slide may temporarily have no width.
       Do nothing until it becomes visible.
    --------------------------------------------------------- */
    if (
      scrollWidth <= 0 ||
      visibleWidth <= 0 ||
      progress.clientWidth <= 0
    ) {
      return;
    }
    /* ---------------------------------------------------------
       No actual horizontal overflow
    --------------------------------------------------------- */
    if (maxScroll <= 1) {
      progress.style.display = 'none';
      thumb.style.width = '';
      thumb.style.transform = '';
      return;
    }
    /* ---------------------------------------------------------
       Thumb width

       Example:
       If 25% of the entire carousel is visible,
       thumb takes approximately 25% of progress track.
    --------------------------------------------------------- */
    var visibleRatio = visibleWidth / scrollWidth;
    /*
      Minimum keeps the indicator usable when there
      are many products.
    */
    var thumbRatio = Math.max(
      Math.min(visibleRatio, 1),
      0.18
    );
    var progressWidth = progress.clientWidth;
    var thumbWidth = progressWidth * thumbRatio;
    thumb.style.width = thumbWidth + 'px';
    /* ---------------------------------------------------------
       Current carousel scroll percentage
    --------------------------------------------------------- */
    var currentScroll = track.scrollLeft;
    /*
      We are LTR, but guard against negative values.
    */
    if (currentScroll < 0) {
      currentScroll = Math.abs(currentScroll);
    }
    var scrollPercentage =
      maxScroll > 0
        ? currentScroll / maxScroll
        : 0;
    scrollPercentage = Math.max(
      0,
      Math.min(scrollPercentage, 1)
    );
    /* ---------------------------------------------------------
       Move thumb through remaining progress-track space
    --------------------------------------------------------- */
    var availableMovement =
      progressWidth - thumbWidth;
    var translateX =
      availableMovement * scrollPercentage;
    thumb.style.transform =
      'translate3d(' +
      translateX +
      'px, 0, 0)';
  }
  /* =========================================================
     BIND SCROLL PROGRESS
  ========================================================= */
  function initHPDShowcaseScrollProgress(root) {
    if (!root) return;
    var track = root.querySelector(
      '[data-hpd-product-showcase-track]'
    );
    if (!track) return;
    /* ---------------------------------------------------------
       Already initialized
    --------------------------------------------------------- */
    if (
      track.dataset.hpdProgressInitialized === 'true'
    ) {
      updateScrollProgress(root);
      return;
    }
    track.dataset.hpdProgressInitialized = 'true';
    /* ---------------------------------------------------------
       RAF throttle prevents excessive calculations during swipe
    --------------------------------------------------------- */
    var ticking = false;
    function requestProgressUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateScrollProgress(root);
        ticking = false;
      });
    }
    /* ---------------------------------------------------------
       Swipe / manual horizontal scrolling
    --------------------------------------------------------- */
    track.addEventListener(
      'scroll',
      requestProgressUpdate,
      {
        passive: true
      }
    );
    /* ---------------------------------------------------------
       ResizeObserver

       Important because this section lives inside Master Slider.
       Width may change when:
       - slide becomes visible
       - orientation changes
       - Theme Editor updates
       - images finish affecting layout
    --------------------------------------------------------- */
    if ('ResizeObserver' in window) {
      var resizeObserver =
        new ResizeObserver(function () {
          requestProgressUpdate();
        });

      resizeObserver.observe(track);

      track._hpdProgressResizeObserver =
        resizeObserver;
    }
    /* ---------------------------------------------------------
       IntersectionObserver

       Important for Master Slider slides.
       Recalculate when the showcase actually becomes visible.
    --------------------------------------------------------- */
    if ('IntersectionObserver' in window) {
      var intersectionObserver =
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                requestProgressUpdate();
              }
            });
          },
          {
            threshold: 0.01
          }
        );
      intersectionObserver.observe(root);
      track._hpdProgressIntersectionObserver =
        intersectionObserver;
    }
    /* ---------------------------------------------------------
       Recalculate after images load
    --------------------------------------------------------- */
    root
      .querySelectorAll('img')
      .forEach(function (image) {
        if (image.complete) return;
        image.addEventListener(
          'load',
          requestProgressUpdate,
          {
            once: true
          }
        );
      });
    /* ---------------------------------------------------------
       First calculations

       Multiple small delays make this safer inside Master Slider,
       because the parent slide/layout may initialize after this JS.
    --------------------------------------------------------- */
    requestProgressUpdate();
    window.setTimeout(
      requestProgressUpdate,
      100
    );
    window.setTimeout(
      requestProgressUpdate,
      300
    );
    window.setTimeout(
      requestProgressUpdate,
      600
    );
  }
  /* =========================================================
     INITIALIZE A SINGLE SHOWCASE
  ========================================================= */
  function initSingleShowcase(section) {
    if (!section) return;
    /* Quick Add */
    section
      .querySelectorAll(
        '[data-hpd-showcase-card]'
      )
      .forEach(function (card) {
        moveQuickAddIntoImage(card);
      });
    /* Scroll progress */
    initHPDShowcaseScrollProgress(section);
    /* Force initial calculation */
    updateScrollProgress(section);
  }
  /* =========================================================
     FIND SHOWCASES WITHIN A SCOPE
  ========================================================= */
  function initShowcase(root) {
    var scope = root || document;
    var sections = [];
    /* Root itself may be the showcase */
    if (
      scope.matches &&
      scope.matches(
        '[data-hpd-product-showcase]'
      )
    ) {
      sections.push(scope);
    }
    /* Or showcases may exist inside root */
    if (scope.querySelectorAll) {
      scope
        .querySelectorAll(
          '[data-hpd-product-showcase]'
        )
        .forEach(function (section) {
          /*
            Prevent duplicate initialization if
            root was already added above.
          */
          if (sections.indexOf(section) === -1) {
            sections.push(section);
          }
        });
    }
    sections.forEach(function (section) {
      initSingleShowcase(section);
    });
  }
  /* =========================================================
     UPDATE ALL PROGRESS BARS
  ========================================================= */
  function updateAllProgressBars() {
    document
      .querySelectorAll(
        '[data-hpd-product-showcase]'
      )
      .forEach(function (section) {
        updateScrollProgress(section);
      });
  }
  /* =========================================================
     WINDOW RESIZE / ORIENTATION
  ========================================================= */
  var resizeTicking = false;
  function handleWindowResize() {
    if (resizeTicking) return;
    resizeTicking = true;
    window.requestAnimationFrame(function () {
      updateAllProgressBars();

      resizeTicking = false;
    });
  }
  window.addEventListener(
    'resize',
    handleWindowResize,
    {
      passive: true
    }
  );
  window.addEventListener(
    'orientationchange',
    function () {
      window.setTimeout(
        updateAllProgressBars,
        150
      );
    }
  );
  /* =========================================================
     INITIAL PAGE LOAD
  ========================================================= */
  function boot() {
    initShowcase(document);
    /*
      One additional update after the complete
      page/media load.
    */
    window.addEventListener(
      'load',
      function () {
        initShowcase(document);
        updateAllProgressBars();
      },
      {
        once: true
      }
    );
  }
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      boot
    );
  } else {
    boot();
  }
  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initShowcase(event.target);
      window.setTimeout(
        updateAllProgressBars,
        100
      );
    }
  );
  document.addEventListener(
    'shopify:block:select',
    function (event) {
      var showcase = event.target.closest(
        '[data-hpd-product-showcase]'
      );
      if (showcase) {
        initSingleShowcase(showcase);
        window.setTimeout(
          function () {
            updateScrollProgress(showcase);
          },
          100
        );
      } else {
        initShowcase(document);
      }
    }
  );
  /* =========================================================
     MASTER SLIDER / GENERAL TRANSITIONS
     When the vertical homepage slider finishes moving to this
     block, calculate the progress again.
  ========================================================= */
  document.addEventListener(
    'transitionend',
    function (event) {
      var slide = event.target.closest
        ? event.target.closest(
            '.master-slider_slide'
          )
        : null;
      if (!slide) return;
      var showcase = slide.querySelector(
        '[data-hpd-product-showcase]'
      );
      if (!showcase) return;
      updateScrollProgress(showcase);
    }
  );
})();